import styled from "styled-components";

export const PopOverContainer = styled.div`
  padding-left: "1.25rem";
`;
